import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'

const ec = LOCALE === 'es-EC'
const arg = LOCALE === 'es-AR'

const Text1ByCountry = () => {
  let text
  if (ec) {
    return (
      <>
        Ingresa tu primera clave personal de cualquier producto Nosotras y
        <b> recibe 5 vidas</b> para activar los planetas.
        <br/><br/>
        <b className="f-pink">Recuerda</b> que debes estar muy
        atenta , porque en el correo que te enviaremos,<b> recibirás una clave
        especial que podrás usar una sola vez.</b>
      </>
    )
  }
  if (arg) {
    text = (
      <>
        Ingresá tu primera clave personal de cualquier producto Nosotras y{' '}
        <b> recibí 5 vidas </b> para activar los planetas.
        <br /> <br />
        <b className="f-pink">Recordá </b>
        que debés estar muy atenta, porque en la visita de Nosotras a tu colegio
        o en tu correo, recibirás una de estas claves especiales.
        <br /> <br />
        <b>¡Podrás usarla una sola vez!</b>
      </>
    )
  } else {
    text = (
      <>
        Ingresa tu primera clave personal de cualquier producto Nosotras y{' '}
        <b> recibe 5 vidas </b> para activar los planetas.
        <br /> <br />
        <b className="f-pink">Recuerda </b>
        que debes estar muy atenta, porque en la visita de Nosotras a tu colegio
        o en tu correo, recibirás una de estas claves especiales.
        <br /> <br />
        <b>¡Podrás usarla una sola vez!</b>
      </>
    )
  }

  return text
}
const Text2ByCountry = () => {
  let text
  if (arg) {
    text = (
      <>
        <b>¡Registrá más claves!</b> Recordá que podés usar:
      </>
    )
  } else {
    text = (
      <>
        <b>¡Registra más claves!</b> Recuerda que puedes usar:
      </>
    )
  }

  return text
}

export const text_replica_modalKeys1 = Text1ByCountry()
export const text_replica_modalKeys2 = Text2ByCountry()
